// removed by extract-text-webpack-plugin
module.exports = {"callout":"callout__callout___gYa5j","heading":"callout__heading___1OCSq","danger":"callout__danger___3ZlkN","warning":"callout__warning___2Gyz1"};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/callout/callout.scss
// module id = 195
// module chunks = 0 1